import axiosClient from "./client_axios";

export const authService = {
  login: (params) => {
    return axiosClient.post(`/user/login`, params);
  },
};
